/*jshint unused: false, undef:false */

'use strict';

/**
 * Adapter for Secure Hashing
 *
 * @version 12.4.0 #756 MLIBJS-121 Add AdapterHash into globalThis for ES6 usage
 *          3.0.0 #249 Refactor wdStorageService versioning
 *
 * @author Dallas Vogels <dvogels@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2016-2020 Build Centrix
 */

var AdapterHash =  function () {

    /**
     * Adapter
     *
     * This object is returned.
     *
     * @since 3.0.0
     *
     * @type {{}}
     */
    var adapter = {};

    /**
     * Get Hash of string
     *
     * @version 3.0.0
     *
     * @param {String} stringData
     * @returns {String}
     */
    adapter.getHash = function(stringData)
    {
        var result;

        var hashEngine = new jsSHA('SHA-1', 'TEXT'); // jshint ignore:line

        hashEngine.update(stringData);

        result = hashEngine.getHash('HEX');

        return result;
    };

    return adapter;
};
globalThis.AdapterHash = AdapterHash;
// EOF